import React from 'react';

function Configuracoes() {
  const configuracoes = {
    usuarios: 'Gerenciamento de Usuários',
    acessos: 'Gestão de Acessos',
    atendometro: 'Gestão de Atendometro',
  };

  return (
    <div>
      <h2>Configurações</h2>
      <p>{configuracoes.usuarios}</p>
      <p>{configuracoes.acessos}</p>
      <p>{configuracoes.atendometro}</p>
    </div>
  );
}

export default Configuracoes;
